import { LicenseInfo } from "@mui/x-license";
// ToDo: expiry date:  Sun Oct 09 2025
export const expirationDate = new Date("2025-10-09");
export const key = "2acb6821751dc6b3542eaeda335ff93fTz05OTU0OSxFPTE3NTk5OTg3ODcwMDAsUz1wcmVtaXVtLExNPXN1YnNjcmlwdGlvbixQVj1pbml0aWFsLEtWPTI=";
export const InitMuiLicense = (licenceKey = key) => LicenseInfo.setLicenseKey(licenceKey);
//# sourceMappingURL=MuiLicense.js.map